// extracted by mini-css-extract-plugin
export default {"container":"tex_MFISm","input":"tex_inp_3psGH","withBorder":"tex_wit_3z20A"};